const INSURED_FAILED_CREATE_TO_EMAIL = 'support-gestion-mail-address';
const INSURED_FAILED_CREATE_FROM_EMAIL = 'no-reply-mail-address';
const INSURED_FAILED_CREATE_SUBJECT = 'failed-create-insured-account-subject' //'Extranet - Pb création compte assuré';
const INSURED_FAILED_CREATE_TEMPLATE = 'failed-create-insured-account-template';

export const INSURED_FAILED_CREATE_ACCOUNT = {
    INSURED_FAILED_CREATE_FROM_EMAIL,
    INSURED_FAILED_CREATE_TO_EMAIL,
    INSURED_FAILED_CREATE_TEMPLATE,
    INSURED_FAILED_CREATE_SUBJECT
}


const INSURED_ACTIVATION_MAIL_FROM_EMAIL = 'no-reply-mail-address';
const INSURED_ACTIVATION_MAIL_SUBJECT = 'activation-mail-insured-account-subject' //'Extranet - Pb création compte assuré';
const INSURED_ACTIVATION_MAIL_TEMPLATE = 'activation-mail-insured-account-template';

export const INSURED_SEND_ACTIVATION_MAIL = {
    INSURED_ACTIVATION_MAIL_FROM_EMAIL,
    INSURED_ACTIVATION_MAIL_SUBJECT,
    INSURED_ACTIVATION_MAIL_TEMPLATE
}

const ADMIN_COMPANY_FAILED_CREATE_TO_EMAIL = 'support-gestion-mail-address';
const ADMIN_COMPANY_FAILED_CREATE_FROM_EMAIL = 'no-reply-mail-address';
const ADMIN_COMPANY_FAILED_CREATE_SUBJECT = 'failed-create-admin-company-account-subject' //'Extranet - Pb création compte Entreprise';
const ADMIN_COMPANY_FAILED_CREATE_TEMPLATE = 'failed-create-admin-company-account-template';

export const ADMIN_COMPANY_FAILED_CREATE_ACCOUNT = {
    ADMIN_COMPANY_FAILED_CREATE_TO_EMAIL,
    ADMIN_COMPANY_FAILED_CREATE_FROM_EMAIL,
    ADMIN_COMPANY_FAILED_CREATE_SUBJECT,
    ADMIN_COMPANY_FAILED_CREATE_TEMPLATE
}
const INSURED_SEND_A_SPECIFIC_REQUEST_TEMPLATE= 'INSURED_SEND_A_SPECIFIC_REQUEST_TEMPLATE';
// const INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_TO= 'support-gestion-mail-address';
const INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_TO = {
    INSURED_SEND_INFORMATIONS_PRESTATIONS: 'support-gestion-informations-prestations-mail-address',
    INSURED_SEND_INFORMATIONS_COTISATIONS: 'support-gestion-informations-cotisations-mail-address',
    INSURED_SEND_CORRECTION_DES_DONNEES: 'support-gestion-correction-des-donnees-mail-address',
    INSURED_SEND_INCIDENT_DE_LAPPLICATION: 'support-gestion-incident-de-lapplication-mail-address',
    INSURED_SEND_AUTRES_DEMANDES: 'support-gestion-autres-demandes-mail-address',
    INSURED_SEND_DISPLAY_PROBLEM: 'support-gestion-display-problem-mail-address',
    INSURED_SEND_OTHERS: 'support-gestion-others-mail-address',
    INSURED_SEND_ADMINISTRATIVE_REQUEST: 'support-gestion-administrative-request-mail-address',

    INSURED_SEND_INFORMATIONS_PRESTATIONS_WORK:             'support-gestion-informations-prestations-work-mail-address',
    INSURED_SEND_INFORMATIONS_PRESTATIONS_DISABLE:          'support-gestion-informations-prestations-disable-mail-address',
    INSURED_SEND_INFORMATIONS_PRESTATIONS_DEATH:            'support-gestion-informations-prestations-death-mail-address',
    
    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_WORK:          'support-gestion-informations-indemnisations-work-mail-address',
    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_DISABLE:       'support-gestion-informations-indemnisations-disable-mail-address',
    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_DEATH:         'support-gestion-informations-indemnisations-death-mail-address',

    INSURED_SEND_AUTRES_DEMANDES_ADDRESS_CHANGE:            'support-gestion-administrative-request-address-change-mail-address',
    INSURED_SEND_AUTRES_DEMANDES_RIB_CHANGE:                'support-gestion-administrative-request-rib-change-mail-address',
    INSURED_SEND_AUTRES_DEMANDES_OTHER:                     'support-gestion-administrative-request-other-mail-address'
};

const INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_SUBJECT = {
    INSURED_SEND_INFORMATIONS_PRESTATIONS_WORK:                 'Déclaration ou prolongation d\'arrêt de travail',
    INSURED_SEND_INFORMATIONS_PRESTATIONS_DISABLE:              'Déclaration ou prolongation d\'invalidité',
    INSURED_SEND_INFORMATIONS_PRESTATIONS_DEATH:                'Déclaration de décès',

    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_WORK:              'Indemnisation d\'arrêt de travail',
    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_DISABLE:           'Indemnisation d\'invalidité',
    INSURED_SEND_INFORMATIONS_INDEMNISATIONS_DEATH:             'Indemnisation de décès',

    INSURED_SEND_AUTRES_DEMANDES_ADDRESS_CHANGE:                'Modification d\'adresse',
    INSURED_SEND_AUTRES_DEMANDES_RIB_CHANGE:                    'Modification de RIB',
    INSURED_SEND_AUTRES_DEMANDES_OTHER:                         'Autres modifications',
}

const INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_FROM= 'no-reply-mail-address';
export const INSURED_SEND_A_SPECIFIC_REQUEST = {
    INSURED_SEND_A_SPECIFIC_REQUEST_TEMPLATE,
    INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_TO,
    INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_FROM,
    INSURED_SEND_A_SPECIFIC_REQUEST_MAIL_SUBJECT
}
